import React from 'react';
import styles from '@dazn/lp-web/src/components/ArticlesRail/articlesRail.module.css';
import {animated} from '@react-spring/web';
import {IArticleTile} from '@dazn/lp-web/src/types';
import {useTileTransitions} from '@dazn/lp-web/src/hooks/useTransitions';
import isQueryParamTrue from '../../utils/isQueryparamTrue';
import classNames from 'classnames';
import {useMedia} from '../../hooks/useMedia';

const ArticlesTile: React.FC<{
    tile: IArticleTile;
    index: number;
    slidesPerView: number;
    disableAnimation: boolean;
    tileBackgroundColor: string;
    showGradient?: boolean;
}> = ({
    tile,
    index,
    slidesPerView,
    disableAnimation = false,
    tileBackgroundColor = 'default'
}) => {
    const {isDesktop} = useMedia();
    const [refView, springs] = useTileTransitions();

    const animations = (() => {
        if (index >= slidesPerView || isQueryParamTrue('seo')) return {};
        return {
            style: springs,
            ref: refView
        };
    })();

    return (
        <animated.article {...(disableAnimation ? {} : animations)}>
            <div
                className={classNames(styles.articleTile, {
                    [styles.tileNonDesktop]: !isDesktop,
                    [styles.dark]: tileBackgroundColor === 'dark',
                    [styles.purple]: tileBackgroundColor === 'purple'
                })}
            >
                <img
                    src={tile?.image.src}
                    className={styles.articleTileImage}
                    alt="Tile Image"
                    data-sync-height="ArticleTileImage"
                />
                <div className={styles.container}>
                    {tile?.logo?.src && (
                        <img
                            className={styles.logo}
                            src={tile?.logo.src}
                            alt="Tile Logo"
                            data-sync-height="ArticleTileLogo"
                        />
                    )}
                    {tile?.title && (
                        <h3
                            className={classNames(styles.title, {
                                [styles.dark]: tileBackgroundColor === 'dark',
                                [styles.purple]: tileBackgroundColor === 'purple'
                            })}
                            data-sync-height="ArticleTileTitle"
                        >
                            {tile.title}
                        </h3>
                    )}
                    {tile?.description && (
                        <p
                            className={classNames(styles.description, {
                                [styles.dark]: tileBackgroundColor === 'dark',
                                [styles.purple]: tileBackgroundColor === 'purple'
                            })}
                            data-sync-height="ArticleTileDesc"
                        >
                            {tile.description}
                        </p>
                    )}
                </div>
            </div>
        </animated.article>
    );
};

export default ArticlesTile;
